// ScrollToTop — ensures every route navigation starts at the top of the page.
//
// Mount inside <BrowserRouter>. Whenever the pathname (or search) changes,
// we reset the window scroll synchronously via useLayoutEffect and disable
// the browser's automatic scroll restoration so SPA nav lands at exactly 0.

import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  // Run once: disable browser's scroll restoration for SPA nav.
  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      try { window.history.scrollRestoration = 'manual'; } catch { /* ignore */ }
    }
  }, []);

  useLayoutEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
    if (document?.documentElement) document.documentElement.scrollTop = 0;
    if (document?.body) document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
